import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div<{ $isShow: boolean }>`
	width: 100%;
	height: 100%;
	overflow: auto;
	display: ${(props) => (props.$isShow ? 'flex' : 'none')};
	flex-direction: column;
	gap: 1.5rem;
	align-items: center;
	justify-content: flex-start;
`;
